import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import './Competition.css';
import Storage from '../services/Storage';
import { Roles } from '../constants/Roles';
import { CommonCompetition } from './CommonComponents';

const Competition = ({ previewData, userId }) => {
  const [segmentWiseTotal, setSegmentWiseTotal] = useState([]);
  const [companyWiseTotal, setCompanyWiseTotal] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ]);
    }
  };

  useEffect(() => {
    getDealerDetails(previewData);
  }, [
    previewData.segment_wise_business_competition,
    previewData.company_wise_business_competition,
  ]);

  const getDealerDetails = (previewData) => {
    if (previewData) {

      let segmentArr = previewData.segment_wise_business_competition && previewData.segment_wise_business_competition.length > 0 ? previewData.segment_wise_business_competition.map((val) => val.turnover) : [];

      let comapnyArr = previewData.company_wise_business_competition && previewData.company_wise_business_competition.length > 0 ? previewData.company_wise_business_competition.map((val) => val.turnover) : [];

      setSegmentWiseTotal(segmentArr);
      setCompanyWiseTotal(comapnyArr);
    }
  };

  return (
    <div id='competitionInsight'>
      <Row>
        <Col xs={12}>
          <div className='d-flex align-items-center'>
            <div className='main-title'>
              Competition Insights
              {roleName &&
                (
                  (roleName === Roles.TM_NAME && (previewData.is_approved === false || (previewData.is_approved === true && previewData.is_required_kyc === true))
                  )
                  ||
                  (roleName === Roles.BH_NAME && (previewData.is_approved === false || (previewData.is_approved === true && previewData.is_required_kyc === true))
                  )
                  ||
                  (roleName === Roles.SH_NAME &&
                    (previewData.is_approved === false || (previewData.is_approved === true && previewData.is_required_kyc === true)))
                ) ? (
                <i
                  onClick={() => {
                    setBreadcrumbsRecord();
                    navigate(
                      `/pages/business-competition-insights/${Storage.getAddNewDealerId()
                        ? Storage.getAddNewDealerId()
                        : userId
                      }`
                    );
                  }}
                  className='fa fa-edit editButton noprint'
                ></i>
              ) : (
                ''
              )}
            </div>
          </div>
        </Col>
        <Col xs={12}>
          {previewData.segment_wise_business_competition &&
            previewData.segment_wise_business_competition.length > 0 && (
              <div className='common-title subTitle companyTitle'>
                Input and company wise last financial year turnover details
              </div>
            )}
        </Col>
        <Col xs={12}>
          <div style={{ borderBottom: '1.2px solid #E9ECEF' }}>
            <CommonCompetition
              totalSegmentTurnOver={segmentWiseTotal}
              totalCompanyTurnOver={companyWiseTotal}
              segmentData={previewData.segment_wise_business_competition}
              companyData={previewData.company_wise_business_competition}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(Competition);
